import { physiosPageContent } from "../../data/physiosPageContent";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import "../../styles/physio.css";

export default function WhyRevimo() {
  const currentLang = useCurrentLang();
  const t = physiosPageContent[currentLang];
  const reasons = [
    {
      icon: "⏱️",
      title: t.whyR.PERKS.t1,
      desc: t.whyR.PERKS.d1,
      button: "",
    },
    {
      icon: "📈",
      title: t.whyR.PERKS.t2,
      desc: t.whyR.PERKS.d2,
      button: "",
    },
    {
      icon: "🔗",
      title: t.whyR.PERKS.t3,
      desc: t.whyR.PERKS.d3,
      button: "",
    },
    {
      icon: "🏗️",
      title: t.whyR.PERKS.t4,
      desc: t.whyR.PERKS.d4,
      button: "[Partner physiotherapists]",
    },
    {
      icon: "🔒",
      title: t.whyR.PERKS.t5,
      desc: t.whyR.PERKS.d5,
      button: "",
    },
    {
      icon: "🚀",
      title: t.whyR.PERKS.t6,
      desc: t.whyR.PERKS.d6,
      button: "",
    },
  ];

  return (
    <section id="why" className="physio-section physio-why">
      <div className="glass-card">
        <span className="physio-eyebrow">{t.whyR.s}</span>
        <h2>{t.whyR.header}</h2>
        <div className="physio-divider" />
        <p className="section-lead">
          {t.whyR.desc1}
        </p>
        <p>
          {t.whyR.desc2}
        </p>
        <p>
          {t.whyR.desc3}
        </p>

        <div className="why-grid">
          {reasons.map(({ icon, title, desc, button }, i) => (
            <div className="why-card" key={i}>
              <span className="why-card-icon" aria-hidden="true">{icon}</span>
              <h4>{title}</h4>
              <p>{desc}</p>
              <button>{button}</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
